import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { LEG_BASIC_Schema } from './LEG_BASIC_Schema';

/**
 * 법규준수평가(LEG_BASIC) 관련 React Query 훅 모음
 */

// 마스터 조회  기본정보
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(LEG_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['LegalCompliance', 'getLegBasicR1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.LegalCompliance.getLegBasicR1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

// 상세 조회 (모달)
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(LEG_BASIC_Schema.mapper.search2, context);
    return apiRequest(
      'post',
      Global.urls.LegalCompliance.getLegBasicR2,
      params
    );
  }, successOptions);
};

// 마스터 삭제 (배열 처리)
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows, context = {}) => {
    const payload = mapRowsBySchema(
      rows,
      LEG_BASIC_Schema.mapper.delete1,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.LegalCompliance.deleteLegBasicD1,
      payload
    );
  }, options);
};

// 상세 삭제 (배열 처리)
export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (rows, context = {}) => {
    const payload = mapRowsBySchema(
      rows,
      LEG_BASIC_Schema.mapper.delete2,
      context
    );
    return apiRequest(
      'post1',
      Global.urls.LegalCompliance.deleteLegBasicD2,
      payload
    );
  }, options);
};

// 상세 저장 (배열 처리)
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows ?? [], LEG_BASIC_Schema.mapper.save1);
    return apiRequest(
      'post1',
      Global.urls.LegalCompliance.saveLegBasicU1,
      payload
    );
  }, options);
};

// 마스터(평가기간) 저장 (배열 처리)
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows ?? [], LEG_BASIC_Schema.mapper.save2);
    return apiRequest(
      'post1',
      Global.urls.LegalCompliance.saveLegBasicU2,
      payload
    );
  }, options);
};
